<kendo-dialog title="{{title}}" [minWidth]="250" [width]="450">
  <ng-container *ngIf="message" class="error">
    <p class="k-dialog-content">{{message}}</p>
  </ng-container>

  <ng-container *ngIf="messages" class="error">
    <ng-container *ngFor="let message of messages">
      <p class="k-dialog-content">{{message}}</p>
    </ng-container>
  </ng-container>

  <table style="margin: auto;">
    <tbody>
    <tr>
      <td>
        <button kendoButton (click)="close()" primary="true">Close</button>
      </td>
    </tr>
    </tbody>
  </table>
</kendo-dialog>
